import { NormalText } from '@Src/commons/StyledComponent';
import { Row } from 'antd';
import React from 'react';
import COLOR from '@Src/commons/Colors';
import InvoiceCard from './InvoiceCard';

export default function InvoiceAccepted({ invoiceData }: any) {
  return (
    <div className="align-items-center flex-column-direction pt-16 pl-24 pr-24 h-gap-24">
      <Row className="screen-width w-100" justify="center">
        <NormalText color={COLOR.PRIMARY_GREEN} fontSize={32} fontWeight={600}>
          Invoice Accepted
        </NormalText>
      </Row>
      <InvoiceCard status="accepted" invoiceData={invoiceData} />
    </div>
  );
}
